function removeNonASCII(source) {
  return source.replace(/[^\x20-\x7E]/g, "");
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  removeNonASCII
};
//# sourceMappingURL=removeNonASCII.js.map
